<template>
  <div class="d-flex justify-center login-recover-window" style="margin: 10vh auto">
    <v-card class="elevation-12" style="width: 100%; min-width: 20vw">
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <div class="py-8 text-center">
            <img src="../../../assets/service-me-logo.png" class="biglogo" />
          </div>
          <v-text-field :disabled="passwordSent" required v-model="password1" label="Password" type="password"
            :hint="passwordHint" :rules="passwordRules" @blur="validatePassword"></v-text-field>
          <v-text-field :disabled="passwordSent" v-model="password2" label="Enter password again" type="password"
            @blur="validatePassword"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="login-actions pa-4" style="display: flex; justify-content: space-between">
        <v-btn v-if="passwordSent" color="primary" href="/sign-in">To login page</v-btn>
        <v-btn :disabled="passwordSent || !isPasswordValid" color="primary" @click="changePassword()">Save new
          password</v-btn>
      </v-card-actions>
      <v-alert v-if="info" type="success">{{ info }}</v-alert>
      <v-progress-linear v-if="loading" :active="loading" indeterminate color="blue"
        style="margin-top: 12px"></v-progress-linear>
    </v-card>
  </div>
</template>

<script>
import { HTTP } from "@/plugins/backendAPI";
import { PasswordPolicyHelper } from "../../../helpers/passwordPolicyHelper";

export default {
  props: ["guid"],
  data() {
    return {
      valid: true,
      loading: false,
      password1: null,
      password2: null,
      info: null,
      passwordSent: false,
      passwordHint: "",
      passwordRules: [],
      passwordPolicyHelper: null,
      passwordPolicy: null,
      isPasswordValid: false,
    };
  },
  created() {
    this.fetchPasswordPolicy();
  },
  methods: {
    async fetchPasswordPolicy() {
      const organizationId = this.$store.getters.organizationid;
      const guid = this.guid;

      if (!organizationId || organizationId === 0 || !guid) {
        console.error("No organization or guid have been selected!");
        return;
      }

      this.loading = true;

      try {
        this.passwordPolicyHelper = new PasswordPolicyHelper();
        await this.passwordPolicyHelper.fetchPasswordPolicy({ guid });

        this.updatePasswordHint();
        this.updatePasswordRules();

        this.validatePassword(); 
      } catch (error) {
        console.error("Error when fetching password policy:", error);
      } finally {
        this.loading = false;
      }
    },

    updatePasswordHint() {
      this.passwordHint = this.passwordPolicyHelper.updatePasswordHint();
    },

    updatePasswordRules() {
      this.passwordRules = this.passwordPolicyHelper.updatePasswordRules();
    },

    validatePassword() {
      const password = this.password1 || '';
      const isPolicyValid = this.passwordPolicyHelper.validatePassword(password);
      const doPasswordsMatch = password === this.password2;

      this.isPasswordValid = isPolicyValid && doPasswordsMatch;
    },
    changePassword() {
      if (this.$refs.form.validate() && this.password1 !== null && this.password1 === this.password2) {
        this.loading = true;
        this.$store.dispatch("setLoading", true);
        HTTP.post("/auth/change-password", { password: this.password1, guid: this.guid })
          .then(() => {
            this.info = "Password is changed. Login with the new password.";
            this.showsnackbar = true;
            this.passwordSent = true;
          })
          .catch((e) => {
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch("showError", e.response.data);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$store.dispatch("showError", "Enter the same password in both fields");
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
